
import SmsNotification from "../../../assets/outline/SmsNotification.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SmsNotificationIcon({ className, dataTestid = "SmsNotificationIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <SmsNotification data-testid={dataTestid} className={classes} {...rest} />
  );
}
